import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massRestoreAgencies } from '../../api/apiAgencies';
import toast from 'react-hot-toast';

export const useMassRestoreAgencies = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massRestoreAgencies,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['agencies'] });
            toast.success(data.message || 'Agencies restored successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to restore agencies';
            toast.error(errorMessage);
        },
    });
};
